import React from "react";

import { kToolbarHeight } from "models";

interface _LayoutWrapperProps {
  menu: React.ReactNode;
  preview: React.ReactNode;
}

// https://www.adobe.com/uk/creativecloud/design/discover/a4-format.html

export const LayoutWrapper = ({ menu, preview }: _LayoutWrapperProps) => {
  return (
    <div
      className="w-[calc(100vw-var(--sidebar-width))] flex flex-row"
      style={{ height: `calc(100vh - ${kToolbarHeight}px)` }}
    >
      <div className="p-4 flex-1 overflow-auto classy-scrollbar">
        <div className="flex justify-center">
          <div
            style={{ minWidth: "600px" }}
            className="shadow-[var(--dms-box-shadow)] bg-[var(--surface-a)] min-h-[calc(67.2rem*var(--editor-scale))] max-w-[calc(60rem*var(--editor-scale))] py-[calc(2rem*var(--editor-scale))] px-[calc(4rem*var(--editor-scale))] rounded-lg"
          >
            <div className="overflow-hidden cursor-pointer pointer-events-none">
              <div className="mb-[3px] flex flex-col">
                <div className="h-4 mb-[3px] bg-[var(--surface-200)] rounded w-[180px]"></div>
                <div className="h-4 mb-[3px] bg-[var(--surface-200)] rounded w-[120px]"></div>
                {preview}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="bg-[var(--surface-a)] border-l border-[var(--surface-border)] shadow-[var(--dms-box-shadow)] z-[1]"
        style={{ width: "360px" }}
      >
        {menu}
      </div>
    </div>
  );
};

export default LayoutWrapper;
